import { Block, Container, Heading, RichText } from '~/components'
import type { ChefsSelectionBlock } from './types'
import Image from 'next/image'
import * as styles from './ChefsSelectionBlock.css'
import { StoryblokAsset } from '~/lib/storyblok'
import { transformImageResize } from '~/lib/storyblok/transformImageResize'
import Link from 'next/link'

type Props = {
  block: ChefsSelectionBlock
}

export function ChefsSelectionBlock({ block }: Props) {
  return (
    <Block options={block.options}>
      <Container>
        <div className={styles.content}>
          <div className={styles.header}>
            <Heading margin="medium">{block.title}</Heading>
            <div className={styles.text}>{block.richtext && <RichText content={block.richtext} />}</div>
          </div>
          <div className={styles.main}>
            <ul className={styles.chefs}>
              {block.chefs.map((chef) => {
                const image =
                  chef.content.image &&
                  transformImageResize(chef.content.image as unknown as StoryblokAsset, {
                    width: 240,
                    height: 240,
                    quality: 100,
                  })

                return (
                  <li key={chef.id} className={styles.chef}>
                    {image && (
                      <Link href={`/${chef.full_slug}`}>
                        <Image src={image.url} alt={image.alt} width={240} height={240} className={styles.chefImage} />
                      </Link>
                    )}
                    <div>
                      <h3 className={styles.chefName}>
                        <Link href={`/${chef.full_slug}`} className={styles.chefNameLink}>
                          {chef.name}
                        </Link>
                      </h3>
                      <div className={styles.chefTeaser}>{chef.content.teaser}</div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Container>
    </Block>
  )
}
